require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-open-house-join-us-every-3rd-thursday.json") })
        }
      }, "path---blog-open-house-join-us-every-3rd-thursday");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-open-house-join-us-every-3rd-thursday!./.cache/json/blog-open-house-join-us-every-3rd-thursday.json
// module id = 1005
// module chunks = 231608221292675